import { render, staticRenderFns } from "./licenseexpiAudit.vue?vue&type=template&id=973a7efa&scoped=true"
import script from "./licenseexpiAudit.vue?vue&type=script&lang=js"
export * from "./licenseexpiAudit.vue?vue&type=script&lang=js"
import style0 from "./licenseexpiAudit.vue?vue&type=style&index=0&id=973a7efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a7efa",
  null
  
)

export default component.exports